import { dynamic } from '#/utils/dynamic';

export const DynamicLazyPdfViewer = dynamic(
  () => import('./PdfViewer').then((module) => ({ default: module.PdfViewer })),
  { strategy: 'client-only' },
);
